<template>
    <div class="drop-orders-block">
        <!-- Блок для управления датами заказов -->
        <div class="selector-drop-orders-date">
            <div class="drop-orders-label">Заказов за:</div>
            <div class="selector-value">
                <div 
                    class="select-period" 
                    :class="{ selected: isToday }"
                    @click="selectToday"
                >
                    Сегодня
                </div>
                <div 
                    class="select-period" 
                    :class="{ selected: !isToday }"
                    @click="selectAllTime"
                >
                    Все время
                </div>
            </div>

            <!-- Отображение количества заказов -->
            <div class="drop-orders-count">{{ ordersCount }}</div>

        </div>
    </div>
</template>

<script>
import api from '@/api/api';

export default {
    data() {
        return {
            isToday: true,
            ordersCount: 0,
            ordersData: {
                orders_today: 0,
                orders_total: 0
            }
        };
    },

    async mounted() {
        await this.loadOrdersData();
        this.updateOrdersCount();
    },

    methods: {
        async loadOrdersData() {
            try {
                const tg_id = localStorage.getItem('tg_id');
                if (!tg_id) {
                    console.error('tg_id не найден в localStorage');
                    return;
                }

                const response = await api.get(`/drop/profile/orders/count/${tg_id}`);
                this.ordersData = response.data;
                this.updateOrdersCount();
                
            } catch (error) {
                console.error('Ошибка при загрузке количества заказов:', error);
                this.ordersCount = 0;
            }
        },

        selectToday() {
            this.isToday = true;
            this.updateOrdersCount();
        },

        selectAllTime() {
            this.isToday = false;
            this.updateOrdersCount();
        },

        updateOrdersCount() {
            this.ordersCount = this.isToday 
                ? this.ordersData.orders_today 
                : this.ordersData.orders_total;
        }
    }
};
</script>

<style scoped>
.drop-orders-block {
    font-family: 'CentureGothic', sans-serif;
    box-sizing: border-box;
    padding: 3vw 2vw;
    background-color: rgba(255, 255, 255, 0.08);
    height: 100%;
    width: 100%;
    border-radius: 10px;
}

.selector-drop-orders-date {
    color: white;
    font-size: 14px;
    font-weight: 600;
}

.drop-orders-label {
    margin-bottom: 2vw;
}

.selector-value {
    background-color: rgba(255, 255, 255, .1);
    border-radius: 15px;
    height: 6vw;
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr;
    padding: .3vw;
    gap: 1vw;
    position: relative;
}

.select-period {
    background-color: rgba(0, 0, 0, .85);
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 15px;
    cursor: pointer;
    width: 100%;

}

.selected {
    background-color: #005ADA;
}

.drop-orders-count {
    margin-top: 4vw;
    width: 100%;
    text-align: center;
    font-size: 40px;
    font-weight: 900;
    color: #005ADA;
}
</style>